"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactVirtualized = require("react-virtualized");

var _material = require("@mui/material");

var CampaignsGrid = function CampaignsGrid(_ref) {
  var renderItem = _ref.renderItem,
      getIsItemFulfilled = _ref.getIsItemFulfilled,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      canFetchMore = _ref.canFetchMore,
      fetchMore = _ref.fetchMore,
      _ref$renderEmpty = _ref.renderEmpty,
      renderEmpty = _ref$renderEmpty === void 0 ? function () {
    return null;
  } : _ref$renderEmpty,
      total = _ref.total;
  var measurerCache = (0, _react.useMemo)(function () {
    return new _reactVirtualized.CellMeasurerCache({
      fixedWidth: true
    });
  }, []);
  var rowsCount = canFetchMore || loading ? total + 10 : total;
  var handleFetchMore = (0, _react.useCallback)(function () {
    if (canFetchMore && !loading) {
      fetchMore();
    }

    return Promise.resolve();
  }, [canFetchMore, fetchMore, loading]);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    flex: "1 1 auto",
    overflow: "hidden"
  }, /*#__PURE__*/_react.default.createElement(_reactVirtualized.InfiniteLoader, {
    loadMoreRows: handleFetchMore,
    isRowLoaded: getIsItemFulfilled,
    rowCount: rowsCount
  }, function (_ref2) {
    var registerChild = _ref2.registerChild,
        onRowsRendered = _ref2.onRowsRendered;
    return /*#__PURE__*/_react.default.createElement(_reactVirtualized.AutoSizer, {
      style: {
        height: '100%',
        width: '100%'
      }
    }, function (_ref3) {
      var height = _ref3.height,
          width = _ref3.width;
      return /*#__PURE__*/_react.default.createElement(_reactVirtualized.Grid, {
        ref: registerChild,
        rowCount: rowsCount,
        rowHeight: measurerCache.rowHeight,
        width: width,
        height: height,
        columnCount: 1,
        columnWidth: width,
        deferredMeasurementCache: measurerCache,
        onSectionRendered: function onSectionRendered(_ref4) {
          var rowStartIndex = _ref4.rowStartIndex,
              rowStopIndex = _ref4.rowStopIndex;
          return onRowsRendered({
            startIndex: rowStartIndex,
            stopIndex: rowStopIndex
          });
        },
        autoContainerWidth: true,
        noContentRenderer: renderEmpty,
        cellRenderer: function cellRenderer(_ref5) {
          var style = _ref5.style,
              parent = _ref5.parent,
              rowIndex = _ref5.rowIndex,
              columnIndex = _ref5.columnIndex;
          return /*#__PURE__*/_react.default.createElement(_reactVirtualized.CellMeasurer, {
            key: "".concat(rowIndex, ".").concat(columnIndex),
            cache: measurerCache,
            parent: parent,
            rowIndex: rowIndex,
            columnIndex: columnIndex
          }, function (_ref6) {
            var registerCell = _ref6.registerChild,
                measure = _ref6.measure;
            return /*#__PURE__*/_react.default.createElement(_material.Box, {
              ref: registerCell,
              style: style
            }, renderItem(rowIndex, measure));
          });
        }
      });
    });
  }));
};

var _default = CampaignsGrid;
exports.default = _default;